import { render, staticRenderFns } from "./gauge-echart.vue?vue&type=template&id=5f60a33f&scoped=true&"
import script from "./gauge-echart.vue?vue&type=script&lang=js&"
export * from "./gauge-echart.vue?vue&type=script&lang=js&"
import style0 from "./gauge-echart.vue?vue&type=style&index=0&id=5f60a33f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60a33f",
  null
  
)

export default component.exports